import { directors } from "@/mocks/films";
import SectionHeading from "./SectionHeading";

export default function Directors() {
  return (
    <section id="directors" className="border-b border-background-200 bg-foreground-950">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs font-label font-medium tracking-wide text-primary-300">
            <i className="ri-vidicon-line"></i>
            导演与风格
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
            看懂一位导演，就看懂了一种表达
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-200/80 md:text-base">
            韩国电影的作者性很强。认识几位代表导演，再看他们的作品，会发现同一份现实能被拍成完全不同的模样。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {directors.map((director) => (
            <article
              key={director.name}
              className="rounded-lg border border-background-50/10 bg-background-50/5 p-5"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 font-heading text-lg font-black text-background-50">
                  {director.initial}
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-background-50">
                    {director.name}
                  </h3>
                  <p className="mt-0.5 text-xs font-label text-accent-300">
                    {director.style}
                  </p>
                </div>
              </div>
              <p className="mt-4 text-sm leading-relaxed text-background-200/80">
                {director.desc}
              </p>
              <p className="mt-4 border-t border-background-50/10 pt-3 text-xs font-label text-background-300/70">
                代表作品 · {director.works}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}